export function shouldBlockParentProductSale(
	variationsFeatureEnabled: boolean,
	allowSellingParentProduct?: boolean | null,
	variationsCount = 0
): boolean {
	return (
		Boolean(variationsFeatureEnabled) &&
		!allowSellingParentProduct &&
		variationsCount > 0
	);
}
